import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface EmptyResultsProps {
    title: string;
    description?: string;
    action?: ReactNode;
    dataTestClass?: string;
}

export const EmptyResults = ({
    title,
    description,
    action,
    dataTestClass,
}: EmptyResultsProps) => {
    const titleMarginBottom = description ? '16px' : action ? '40px' : 0;

    return (
        <Box
            data-testclass={dataTestClass}
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '24px',
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Open Sans',
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: 'normal',
                    textAlign: 'center',
                    color: 'common.black',
                    marginBottom: titleMarginBottom,
                }}
            >
                {title}
            </Typography>
            {description ? (
                <Typography
                    sx={{
                        fontFamily: 'Open Sans',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: 'normal',
                        textAlign: 'center',
                        color: 'common.black',
                        maxWidth: '586px',
                        marginBottom: action ? '40px' : 0,
                    }}
                >
                    {description}
                </Typography>
            ) : null}
            {action}
        </Box>
    );
};
